import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";

/* ---------------- POST: CREATE LEAD BATCH ---------------- */

export const leadBatchApi = createAsyncThunk(
  "leadBatch/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiEndpoints.leadBatchAPi, payload, {
        headers: { "Content-Type": "application/json" },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  }
);

/* ---------------- GET: FETCH BY SESSION ---------------- */

export const fetchLeadBatchItemsBySession = createAsyncThunk(
  "leadBatch/fetchBySession",
  async (_, { rejectWithValue }) => {
    const token = localStorage.getItem("token");
    try {
      const sessionId = localStorage.getItem("sessionId");
      if (!sessionId) {
        return rejectWithValue("Session ID not found");
      }

      const response = await axios.get(
        apiEndpoints.leadBatchItemsBySession(sessionId),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // pass token here
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch lead batch items"
      );
    }
  }
);

/* ---------------- SLICE ---------------- */

const leadBatchSlice = createSlice({
  name: "leadBatch",
  initialState: {
    loading: false,
    error: null,

    createResponse: null, // POST result
    itemsBySession: [], // GET result
  },
  reducers: {
    resetLeadBatch(state) {
      state.loading = false;
      state.error = null;
      state.createResponse = null;
      state.itemsBySession = [];
    },
  },
  extraReducers: (builder) => {
    builder
      /* CREATE */
      .addCase(leadBatchApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(leadBatchApi.fulfilled, (state, action) => {
        state.loading = false;
        state.createResponse = action.payload;
      })
      .addCase(leadBatchApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* FETCH BY SESSION */
      .addCase(fetchLeadBatchItemsBySession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeadBatchItemsBySession.fulfilled, (state, action) => {
        state.loading = false;
        state.itemsBySession = action.payload;
      })
      .addCase(fetchLeadBatchItemsBySession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetLeadBatch } = leadBatchSlice.actions;
export default leadBatchSlice.reducer;
